<button (click)="toggleVisibility()"
  mat-icon-button
  type="button">
  <mat-icon>{{ type === 'password' ? 'visibility' : 'visibility_off' }}</mat-icon>
</button>